import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPartnerId } from '@redux/reducers/slices/user';
import { selectIsPartnerUser } from '@redux/selectors/user';
import { useQueryClient } from 'react-query';
import { useCustomMutation } from '@hooks/useMutationWithBackendErrors';
import { DELETE, PARTNER, PROJECT_ADDITION_TEMPLATES } from '@variables/queryKeys';
import { deleteProjectAdditionTemplate } from '@services/api/projectAdditionTemplates/projectAdditionTempaltes';

export const useDeleteProjectAdditionTemplate = (options?: { onSuccess?: () => void }) => {
  const { partnerId: partnerIdParams } = useParams<{ partnerId: string }>();
  const partnerId = useSelector(selectPartnerId);
  const isPartnerUser = useSelector(selectIsPartnerUser);

  const selectedPartnerId = isPartnerUser ? partnerId : Number(partnerIdParams);
  const queryClient = useQueryClient();
  const { mutate, mutateAsync, isLoading } = useCustomMutation({
    mutationKey: [DELETE, PROJECT_ADDITION_TEMPLATES],
    mutationFn: deleteProjectAdditionTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries([PARTNER, PROJECT_ADDITION_TEMPLATES, selectedPartnerId]);
      options?.onSuccess?.();
    },
  });

  return {
    isDeletingProjectAdditionTemplate: isLoading,
    deleteProjectAdditionTemplate: mutate,
    deleteProjectAdditionTemplateAsync: mutateAsync,
  };
};
